module.exports = __webpack_public_path__ + "static/media/anage-oferta-imoveis@2x.8a718db0.png";